<template>
	<div class="flex">
		<AccessRestrictedButton v-for="buttonStyle in buttonStyles" :key="buttonStyle.buttonNameKey"
								:permission="enumDef.permissions.InvestorExchangeAlfa"
								:button-class="buttonStyle.buttonClass"
								:button-name-key="buttonStyle.buttonNameKey"
								:icon-class="buttonStyle.iconClass" :icon-style="buttonStyle.iconStyle"
								:no-access-display-type="enumDef.noAccessDisplayType.Hide"
								@click="buttonStyle.click"
								:disabled="buttonStyle.disabled"
								style="margin-right: 5px;"
		/>
	</div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import AccessRestrictedButton from "@/components/templates/common/permissions/AccessRestrictedButton.vue";

export default {
	components: { AccessRestrictedButton },
	props: {
		status: { type: Number, default: null },
	},
	data() {
		return {
			enumDef: enumDef
		};
	},
	computed: {
		buttonStyles() {
			let activeButtons = [
				{
					buttonClass: "md-primary-dark",
					buttonNameKey: "investor.exchange.button.alfaSettings",
					iconClass: "",
					iconStyle: "",
					click: this.showSettings
				}
			];

			if (this.status === null || this.status === enumDef.alfaSettingsStatus.NotActive) {
				activeButtons.push({
					buttonClass: this.status !== null ? "md-success" : "",
					buttonNameKey: "investor.exchange.button.startAlfa",
					iconClass: "fa fa-play",
					iconStyle: "top: 1px;",
					click: this.startAlfa,
					disabled: this.status === null
				});
			} else if (this.status === enumDef.alfaSettingsStatus.Active) {
				activeButtons.push({
					buttonClass: "md-danger",
					buttonNameKey: "investor.exchange.button.stopAlfa",
					iconClass: "fa fa-pause",
					iconStyle: "top: 2px;",
					click: this.stopAlfa
				});
			}

			return activeButtons;
		},
	},
	methods: {
		showSettings() {
			this.$emit("show");
		},
		startAlfa() {
			this.$emit("start");
		},
		stopAlfa() {
			this.$emit("stop");
		}
	}
};
</script>